import {
  LinearProgress,
  linearProgressClasses,
  LinearProgressProps,
  Typography,
} from "@mui/material";
import styled from "@mui/material/styles/styled";

import { SemanticScore, getSemanticScore } from "@app/common/utils";

import { Row, StackProps } from "@rui/Stack";

type BarProps = LinearProgressProps & { score: SemanticScore };

const Bar = styled(({ score: _, ...props }: BarProps) => (
  <LinearProgress {...props} />
))(({ score, theme }) => ({
  height: "8px",
  borderRadius: "4px",
  flex: 1,
  backgroundColor: theme.palette.shades.neutral[100],
  [`& .${linearProgressClasses.bar}`]: {
    backgroundColor:
      score === "positive"
        ? theme.palette.shades.meadow[500]
        : score === "neutral"
          ? theme.palette.shades.orange[500]
          : score === "negative"
            ? theme.palette.shades.negative[500]
            : "transparent",
  },
}));

export interface ScoreProgressProps extends StackProps {
  value: number | null;
}

const ScoreProgress = ({ value, ...rowProps }: ScoreProgressProps) => (
  <Row variant="apart" spacing={1} {...rowProps}>
    <Bar
      value={value ?? 0}
      variant="determinate"
      score={getSemanticScore(value)}
    />
    <Typography
      variant="bodySecondaryReg"
      sx={{ color: "shades.neutral.700", minWidth: "22px", textAlign: "right" }}
    >
      {value ?? "-"}
    </Typography>
  </Row>
);

export default ScoreProgress;
